import React, { Component } from 'react';
import Menu from 'choerodon-ui/lib/menu';
import { MentionsContextConsumer } from './MentionsContext';
const { Item } = Menu;
/**
 * We only use Menu to display the candidate.
 * The focus is controlled by textarea to make accessibility easy.
 */
class DropdownMenu extends Component {
    constructor() {
        super(...arguments);
        this.renderDropdown = ({ notFoundContent, activeIndex, setActiveIndex, selectOption, onFocus, onBlur, }) => {
            const { options } = this.props;
            const activeOption = options[activeIndex] || {};
            const handleClick = ({ key }) => {
                const option = options.find(({ key: optionKey }) => optionKey === key);
                if (option) {
                    selectOption(option);
                }
            };
            const selectedKeys = activeOption && activeOption.key ? [activeOption.key] : [];
            return (React.createElement(Menu, { selectedKeys: selectedKeys, onClick: handleClick, onFocus: onFocus, onBlur: onBlur, focusable: true },
                options.map((option, index) => {
                    const { key, disabled, children, className, style } = option;
                    return (React.createElement(Item, { key: key, disabled: disabled, className: className, style: style, onMouseEnter: () => {
                            setActiveIndex(index);
                        } }, children));
                }),
                !options.length && React.createElement(Item, { disabled: true }, notFoundContent)));
        };
    }
    render() {
        return React.createElement(MentionsContextConsumer, null, this.renderDropdown);
    }
}
export default DropdownMenu;
